import React from "react";
import axios from "axios";
import "./style.css";
import theme from "../../../Theme/theme";
import Modal from './Modal';
import SlideSwitch from "components/SlideSwitch";
import { toast } from "react-toastify";
import { alert, isValidUrl } from "../../../common/Utils"
import { Constants } from "../../../common/constants"
import { API_URL, ADJUST_TRACKING_KEY, VIRTUAL_TRAINING_NAVIGATION_KEY, ERROR_HANDLE } from "config/constants";

const TRIANGLE_DOWN_IMAGE = require('../../../assets/images/dynamicPricing/triangle_down.png');
const SUCCESS = "Adjust config saved successfully!";
const FAILED = "Failed to save adjust config";
const ALERT_URL = "Please enter a valid adjust tracking url";
const ADJUST_TITLE = "Config for the Adjust Tracking"
const VIRTUAL_TRAINING_TITLE = "Set Default Navigation Flow"
const SEARCH_TEXT = "SELECT PROMO CODE"
const CONSTRUCT_URL_TEXT = "Construct Adjust Tracking URL"

class AdminConfigScreen extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            adjustTrackingUrl: "",
            promocode: "",
            showPromocodeListPopup: false,
            virtualTrainingNavigation: false
        }
        this.promocodeList = [];
    }

    componentDidMount = () => {
        this.fetchAdjustConfig()
        this.fetchVirtualTrainingNavigateConfig()
    }

    fetchAdjustConfig = () => {
        const access_token = localStorage.getItem("access_token");
        axios.get(`${API_URL}/admin/configs/${ADJUST_TRACKING_KEY}`, {
            headers: {
                "x-access-token": access_token
            },
        }).then(res => {
            let { value } = res.data;
            value && this.setState({
                adjustTrackingUrl: value.ADJUST_TRACKING_URL || "",
                promocode: value.ADJUST_TRACKING_PROMO_CODE || ""
            })
        }).catch(error => {
            ERROR_HANDLE(error)
        });
    }

    fetchVirtualTrainingNavigateConfig = () => {
        const access_token = localStorage.getItem("access_token");
        axios.get(`${API_URL}/admin/configs/${VIRTUAL_TRAINING_NAVIGATION_KEY}`, {
            headers: {
                "x-access-token": access_token
            },
        }).then(res => {
            let response = res.data;
            if (response.value == "true") this.setState({ virtualTrainingNavigation: true});
        }).catch(error => {
            ERROR_HANDLE(error)
        });
    }

    toggleVirtualTrainingNavigation = (activeState) => {
        const access_token = localStorage.getItem("access_token");
        const SUCCESS = "Default navigation config saved successfully!";
        const FAILED = "Failed to save default navigation config";
        const data = {
            key: VIRTUAL_TRAINING_NAVIGATION_KEY,
            value: activeState ? "true" : "false",
            is_json: false
        }
        axios.post(`${API_URL}/admin/configs/`, data, {
            headers: {
                "x-access-token": access_token
            },
        }).then(response => {
            if (response.status == 200) {
                this.setState({ virtualTrainingNavigation: activeState });
                toast.success(SUCCESS, { autoClose: Constants.TOAST_TIME_OUT });
            }
            else toast.error(FAILED, { autoClose: Constants.TOAST_TIME_OUT });
        }).catch(error => {
            ERROR_HANDLE(error);
        });
    }

    save = () => {
        if (isValidUrl(this.state.adjustTrackingUrl)) {
            const access_token = localStorage.getItem("access_token");
            const data = {
                key: ADJUST_TRACKING_KEY,
                value: {
                    ADJUST_TRACKING_URL: this.state.adjustTrackingUrl,
                    ADJUST_TRACKING_PROMO_CODE: ""
                },
                is_json: true
            }
            axios.post(`${API_URL}/admin/configs/`, data, {
                headers: {
                    "x-access-token": access_token
                },
            }).then(response => {
                if (response.status == 200) toast.success(SUCCESS, { autoClose: Constants.TOAST_TIME_OUT });
                else toast.error(FAILED, { autoClose: Constants.TOAST_TIME_OUT });
            }).catch(error => {
                ERROR_HANDLE(error);
            });
        } else alert(ALERT_URL);
    }

    /**
     * @description this is the props method gets handled from promocode list component to avoid promocode API call every time.
     * @param promocodeList - the promocodeList value will receive from promocode list component
     */
    updatePromocodeList = (promocodeList) => {
        this.promocodeList = promocodeList
    }

    /**
     * @description this is the props method gets handled from promocode list
     * @param promocode - the promocode value will receive from promocode list component
     */
    updateSelectedPromoCode = (promo) => {
        this.setState({
            promocode: promo.promocode,
            showPromocodeListPopup: false
        })
    }

    render() {
        return (
            <div className="root">
                <div className="background">
                    <p style={style.title}>{ADJUST_TITLE}</p>
                    <div className="container">
                        <div className="row">
                            <div className="column" style={style.textBlack}>Adjust Tracking Url</div>
                            <input
                                value={this.state.adjustTrackingUrl}
                                style={style.input}
                                disableUnderline={true}
                                onChange={e => {
                                    this.setState({
                                        adjustTrackingUrl: e.target.value
                                    });
                                }}
                            />
                            <div className="save-button" style={style.saveButton} onClick={this.save}>Save</div>
                        </div>
                    </div>
                    <div className="row">
                            <div className="column" style={style.textBlack}>{CONSTRUCT_URL_TEXT}</div>
                    </div> 
                    <div className="row">
                        <div
                            style = { style.buttonStyle }
                            onClick = {
                                () => { this.setState({ showPromocodeListPopup: true }) } } > { SEARCH_TEXT } 
                                <img style = {style.image} src = { TRIANGLE_DOWN_IMAGE }/>
                        </div> 
                        <div className="input-row">
                            {this.state.adjustTrackingUrl + "?label=" + this.state.promocode}
                        </div>
                    </div>
                </div>
                {
                    this.state.showPromocodeListPopup &&
                    <Modal
                        promocodeList={this.promocodeList}
                        updatePromocodeList={(promocodeList) => this.updatePromocodeList(promocodeList)}
                        updateSelectedPromoCode={(promo) => this.updateSelectedPromoCode(promo)}
                        close={() => this.setState({ showPromocodeListPopup: false })} />
                }
                <div className="background">
                    <p style={style.title}>{VIRTUAL_TRAINING_TITLE}</p>
                    <div className="container">
                        <div className="row">
                            <div className="column" style={style.textBlack}>Virtual Training Navigation</div>
                            <SlideSwitch
                                style={style.sliderStyle}
                                checked={this.state.virtualTrainingNavigation}
                                onClick={() => {
                                    this.toggleVirtualTrainingNavigation(!this.state.virtualTrainingNavigation);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

const style = {
    title: {
        fontSize: 20,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.thickGrey,
        textAlign: 'center'
    },
    input: {
        fontSize: 18,
        color: theme.color.black,
        marginLeft: 20,
        paddingLeft: 20,
        textAlign: "left",
        height: "auto",
        width: "340px",
        backgroundColor: theme.color.textLightWhite,
        border: "none"
    },
    saveButton: {
        display:"flex",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "center",
        backgroundColor: theme.color.primaryBlue,
        width: 100,
        height: "50px",
        marginLeft: "10px",
    },
    sliderStyle: {
        alignSelf: "center",
        flex: 1,
        minWidth: 75
    },
    textBlack: {
        fontSize: 18,
        padding: 5,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.mediumGrey,
        textAlign: 'center',
        marginRight: 25
    },
    buttonStyle: {
        display: "flex",
        lineHeight: "60px",
        padding:"0px 7px",
        borderRadius: 10,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        fontSize: 17,
        backgroundColor: theme.color.primaryBlue,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.textLightWhite,
    },
    image: { 
        width: 37, 
        height: 26, 
        marginTop: 17, 
        marginLeft: 8 
    }
}

export default AdminConfigScreen
